import ExtLink from '../../controls/ExtLink';
import { Icon } from '../../display';
import classes from './MainMenu.module.scss';

export default function BottomBlock() {
  return (
    <ul className={classes.root}>
      <li className={classes.item}>
        <ExtLink
          className={classes.link}
          href="https://www.notion.so/pulseapp/Pulse-Setup-Wiki-1a4dda92525944a3ae6ee7f73f75cf18"
        >
          <Icon className={classes.icon} icon="question-circle" size="medium" />
          Help Center
        </ExtLink>
      </li>
    </ul>
  );
}
